import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'Brain',
      title: 'AI Opponents',
      description: 'Battle against multiple AI personalities with unique psychological tactics',
      gradient: 'from-primary/20 to-primary/5',
    },
    {
      icon: 'Gem',
      title: 'Gem Rewards',
      description: 'Earn rare gems through hard-fought victories and unlock exclusive content',
      gradient: 'from-accent/20 to-accent/5',
    },
    {
      icon: 'Flame',
      title: 'Streak System',
      description: 'Build winning streaks and climb the difficulty ladder for greater challenges',
      gradient: 'from-warning/20 to-warning/5',
    },
    {
      icon: 'Trophy',
      title: 'Achievements',
      description: 'Unlock new AI moods and special features as you progress through the game',
      gradient: 'from-secondary/20 to-secondary/5',
    },
  ];

  return (
    <div className="space-y-md">
      <div className="flex items-center gap-sm pb-sm border-b border-secondary/30">
        <Icon name="Sparkles" size={24} color="var(--color-secondary)" />
        <h3 className="text-lg font-heading font-semibold text-secondary">
          What You'll Get
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-sm">
        {benefits?.map((benefit, index) => (
          <div
            key={index}
            className={`p-md bg-gradient-to-br ${benefit?.gradient} rounded-sm border border-primary/20 hover:border-primary/40 transition-all duration-base hover:scale-105`}
          >
            <div className="flex items-start gap-sm mb-sm">
              <div className="flex-shrink-0 w-8 h-8 bg-card rounded-sm flex items-center justify-center border border-primary/30">
                <Icon name={benefit?.icon} size={18} color="var(--color-primary)" />
              </div>
              <h4 className="text-sm font-caption font-semibold text-foreground">
                {benefit?.title}
              </h4>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {benefit?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="pt-sm">
        <div className="p-md bg-card rounded-sm border-2 border-primary shadow-glow-cyan-sm">
          <div className="flex items-center gap-sm mb-sm">
            <Icon name="Zap" size={20} color="var(--color-primary)" />
            <h4 className="text-sm font-caption font-semibold text-primary">
              Start Your Journey
            </h4>
          </div>
          <p className="text-xs text-muted-foreground leading-relaxed">
            Join thousands of players in the ultimate psychological gaming experience. Create your account now and dive into the cyberpunk world of CyberOddEven!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;